import { render } from "./UserCreation.vue?vue&type=template&id=0700a83e&ts=true"
import script from "./UserCreation.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserCreation.vue?vue&type=script&setup=true&lang=ts"

import "./UserCreation.vue?vue&type=style&index=0&id=0700a83e&lang=css"

import exportComponent from "/codebuild/output/src3693190966/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/userinfo/UserCreation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0700a83e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0700a83e', __exports__)) {
    console.log('reload')
    api.reload('0700a83e', __exports__)
  }
  
  module.hot.accept("./UserCreation.vue?vue&type=template&id=0700a83e&ts=true", () => {
    console.log('re-render')
    api.rerender('0700a83e', render)
  })

}


export default __exports__